"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.setupAccountEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/account');
var getBasePathV3 = (0, utils_1.getBasePathFactoryV3)('/account');
function setupAccountEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            submitTermsAcceptLink: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, token = _a.token;
                    return ({
                        url: "".concat(getBasePath(customerId), "/terms/tokenized-accept"),
                        method: 'POST',
                        body: { token: token }
                    });
                }
            }),
            verifyEmailLink: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, token = _a.token;
                    return ({
                        url: "".concat(getBasePath(customerId), "/email/verify"),
                        method: 'POST',
                        body: { token: token }
                    });
                }
            }),
            sendAgreements: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, agreementTypes = _a.agreementTypes;
                    return ({
                        url: "".concat(getBasePath(customerId), "/agreements/send"),
                        method: 'POST',
                        body: {
                            delivery_method: 'EMAIL',
                            agreement_types: agreementTypes
                        }
                    });
                }
            }),
            getPendingAgreements: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/agreements/pending"),
                        method: 'GET',
                        extraOptions: { maxRetries: 3 }
                    });
                }
            }),
            ignoreAgreements: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/agreements/ignore"),
                        method: 'POST'
                    });
                }
            }),
            acceptAgreements: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, agreementTypes = _a.agreementTypes;
                    return ({
                        url: "".concat(getBasePath(customerId), "/agreements"),
                        method: 'POST',
                        body: { agreement_types: agreementTypes }
                    });
                }
            }),
            postEmailVerification: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/verify-email"),
                        method: 'POST'
                    });
                }
            }),
            getAutopilotEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/autopilot/eligibility");
                }
            }),
            enableAutopilot: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/autopilot/enable"),
                        method: 'POST'
                    });
                }
            }),
            disableAutopilot: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/autopilot/disable"),
                        method: 'POST'
                    });
                }
            }),
            updateEstimatedBillAmount: build.mutation({
                query: function (_a) {
                    var estimated_bill_amount_cent = _a.estimated_bill_amount_cent, customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/update-estimated-bill-amount"),
                        method: 'POST',
                        body: { estimated_bill_amount_cent: estimated_bill_amount_cent }
                    });
                }
            }),
            updateCreditUtilizationAmount: build.mutation({
                query: function (_a) {
                    var credit_utilization_cent = _a.credit_utilization_cent, customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/update-credit-utilization-amount"),
                        method: 'POST',
                        body: { credit_utilization_cent: credit_utilization_cent }
                    });
                }
            }),
            getPaymentSchedule: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, override_estimated_bill_amount_cent = _a.override_estimated_bill_amount_cent;
                    return ({
                        url: "".concat(getBasePath(customerId), "/payment-schedule"),
                        method: 'GET',
                        params: { override_estimated_bill_amount_cent: override_estimated_bill_amount_cent }
                    });
                }
            }),
            getRentReportingOptIn: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/rent-reporting/opt-in");
                }
            }),
            updateRentReportingOptIn: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, opt_in_status = _a.opt_in_status;
                    return ({
                        url: "".concat(getBasePath(customerId), "/rent-reporting/opt-in"),
                        method: 'POST',
                        body: { opt_in_status: opt_in_status }
                    });
                }
            }),
            getDeleteEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/delete/eligibility");
                }
            }),
            generateMagicLink: build.mutation({
                query: function (body) { return ({
                    url: "".concat(getBasePath(), "/magic-link/generate"),
                    method: 'POST',
                    body: body
                }); }
            }),
            validateMagicLink: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/magic-link/validate"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            generateAuthToken: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePathV3(customerId), "/auth/token"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            validateAuthToken: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePathV3(customerId), "/auth/token/validate"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            generateAdaToken: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/ada-token"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            getRxpEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, isNewCustomer = _a.isNewCustomer, deviceId = _a.deviceId;
                    return ({
                        url: "".concat(getBasePathV3(customerId), "/rxp/eligibility"),
                        method: 'GET',
                        params: { isNewCustomer: isNewCustomer, deviceId: deviceId }
                    });
                }
            }),
            sendPhoneUpdateEmail: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/phone/update/start-email-verification"),
                        method: 'POST'
                    });
                }
            }),
            sendPhoneUpdateCode: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/phone/update/start-phone-verification"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            verifyPhoneUpdateCode: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/phone/update/verify-phone"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            getRelinkEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/relink/eligibility");
                }
            }),
            getSLCStatus: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/slc");
                }
            }),
            enableSimplifiedPayments: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/slc/simplified-payments/enable"),
                        method: 'POST'
                    });
                }
            }),
            disableSimplifiedPayments: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/slc/simplified-payments/disable"),
                        method: 'POST'
                    });
                }
            }),
            getAccount: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return getBasePath(customerId);
                }
            }),
            deleteAccount: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/delete"),
                        method: 'POST'
                    });
                }
            }),
            getCreditSummary: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/credit-builder");
                }
            }),
            getReportingHistory: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, limit = _a.limit;
                    return limit
                        ? "".concat(getBasePath(customerId), "/credit-builder/reporting-history?limit=").concat(limit)
                        : "".concat(getBasePath(customerId), "/credit-builder/reporting-history");
                }
            }),
            getAccountFeatures: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/features");
                }
            }),
            getAccountV3: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, categoryType = _a.categoryType;
                    return ({
                        url: "".concat(getBasePathV3(customerId)),
                        method: 'GET',
                        params: { categoryType: categoryType }
                    });
                }
            }),
            /**
             * @description this is for use in onboarding only
             */
            setupAutopilot: build.mutation({
                query: function (_a) {
                    var status = _a.status, customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/setup-autopilot"),
                        method: 'POST',
                        body: { status: status }
                    });
                }
            }),
            setPortalCredentials: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/portal/credentials"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            upsertUserAccount: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/upsert"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            autopilotSetup: build.mutation({
                query: function (_a) {
                    var status = _a.status, customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/autopilot/setup"),
                        method: 'POST',
                        body: { status: status }
                    });
                }
            }),
            getCreditBuilderConversionEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/credit-builder/conversion-eligibility"),
                        method: 'GET'
                    });
                }
            }),
            convertOfferToCreditBuilder: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/credit-builder/convert-offer"),
                        method: 'POST'
                    });
                }
            }),
            updatePortalCredentials: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, body = __rest(_a, ["customerId"]);
                    return ({
                        url: "".concat(getBasePath(customerId), "/portal/credentials"),
                        method: 'POST',
                        body: body
                    });
                }
            }),
            getIterableJWT: build.query({
                query: function (body) { return ({
                    url: "".concat(getBasePath(), "/iterable/jwt"),
                    method: 'POST',
                    body: body
                }); }
            }),
            getIterableSubscriptions: build.query({
                query: function (_a) {
                    var email = _a.email;
                    return ({
                        url: "".concat(getBasePath(), "/iterable/subscriptions?email=").concat(email),
                        method: 'GET'
                    });
                }
            }),
            updateIterableSubscriptions: build.mutation({
                query: function (body) { return ({
                    url: "".concat(getBasePath(), "/iterable/subscriptions"),
                    method: 'POST',
                    body: body
                }); }
            }),
            continueEvaluation: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/onboarding/continue-evaluation"),
                        method: 'POST',
                        body: {}
                    });
                }
            })
        }); }
    });
}
exports.setupAccountEndpoints = setupAccountEndpoints;
